import { Button, Chip, Stack, Typography } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"
import { MaintenanceTaskActions } from "../component-library-slot-definitions"
import { buildVersionLabel, formatDateTime } from "../lib/task-version-utils"
import { DraftChip } from "./draft-chip"

export function TaskReadOnlyHeader({ task, historyItem, historicalMode, canEdit, onEdit }) {
    return (
        <Stack spacing={1}>
            <Stack direction="row" spacing={2} alignItems="flex-start" justifyContent="space-between">
                <Typography variant="h5" sx={{ minWidth: 0 }}>
                    {task.heading}
                </Typography>
                <If value={canEdit}>
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<Iconify icon="eva:edit-outline" />}
                        onClick={onEdit}
                        sx={{ flexShrink: 0 }}
                        data-cy="task-edit-button"
                    >
                        Edit
                    </Button>
                </If>
                <Bound task={task}>
                    <MaintenanceTaskActions.Slot />
                </Bound>
            </Stack>
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                <If value={historyItem}>
                    <Chip size="small" color="primary" label={buildVersionLabel(historyItem)} />
                </If>
                <If value={historicalMode}>
                    <Chip size="small" variant="outlined" label="Historical view" />
                </If>
                <If value={task.frequencyCode}>
                    <Chip size="small" variant="outlined" label={task.frequencyCode} />
                </If>
                <If value={task.skillSet}>
                    <Chip size="small" variant="outlined" label={task.skillSet} />
                </If>
                <If value={task.taskType}>
                    <Chip size="small" variant="outlined" label={task.taskType} />
                </If>
                <DraftChip item={task} />
            </Stack>
            <If value={historyItem?.createdAt}>
                <Typography variant="caption" color="text.secondary">
                    Snapshot from {formatDateTime(historyItem?.createdAt)}
                </Typography>
            </If>
        </Stack>
    )
}
